








































































































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import VueVideoSection from 'vue-video-section';
import { BrandAssetWrite } from '../../common/types';
import tagModule from '../../store/modules/tag.module';
import brandModule from '../../store/modules/brand.module';
import { ASSET_URL, VIDEO_ID } from '../../common/config';
import errorModule from '../../store/modules/error.module';
import { eventBus } from '../../main';
import { SHOW_SNACKBAR } from '../../common/constants';
import Tag from '../../common/model/Tag';

const placeholderAsset: BrandAssetWrite = {
  title: '',
  description: '',
  tags: [],
  category: '',
  img: require('@/assets/admin/placeholder.jpg'),
  brand_id: '',
  is_archived: false,
  featured: false,
};

@Component({
  components: {
    VueVideoSection,
  },
})
export default class AdminVideoVaultCard extends Vue {
  @Prop() asset: any;

  @Prop({ default: false }) isCreateAssetCard: boolean;

  localAsset = placeholderAsset;

  cdnUrl = ASSET_URL;

  assetFile: File | null = null;

  brandModule = brandModule;

  get availableTags(): Array<Tag> {
    return tagModule.tags;
  }

  mounted(): void {
    this.localAsset = this.asset;
  }

  playVideo(): void {
    const videoRef: any = this.$refs[`video-${this.asset.id}`];
    videoRef.playVideo();
  }

  pauseVideo(): void {
    const videoRef: any = this.$refs[`video-${this.asset.id}`];
    videoRef.pauseVideo();
  }

  async archiveAsset(): Promise<void> {
    this.localAsset.is_archived = !this.asset.is_archived;
    await brandModule.updateBrandAsset({ asset: this.localAsset });
    errorModule.clearError();
  }

  async updateAsset(): Promise<void> {
    if (!brandModule.brand) {
      return;
    }

    this.localAsset.brand_id = brandModule.brand.id;
    if (this.assetFile) {
      this.localAsset.img = this.assetFile.name;
      if (this.assetFile.type === 'image/gif') {
        eventBus.$emit(
          SHOW_SNACKBAR,
          'GIF files are not supported in the Video Vault. Please upload in the Brand Center instead.',
        );
        return;
      }
      this.showTimeEstimate();
    }

    await brandModule.updateBrandAsset({
      asset: this.localAsset,
      assetFile: this.assetFile,
    });
    if (errorModule.hasError) {
      errorModule.clearError();
      return;
    }
    eventBus.$emit(SHOW_SNACKBAR, 'Asset successfully updated.');
  }

  async createAsset(): Promise<void> {
    if (!brandModule.brand || !this.assetFile) {
      eventBus.$emit(
        SHOW_SNACKBAR,
        'You must choose a video to upload to create an asset.',
      );
      return;
    }
    this.localAsset.category = VIDEO_ID;
    this.localAsset.brand_id = brandModule.brand.id;
    this.localAsset.img = this.assetFile.name;
    if (this.assetFile.type === 'image/gif') {
      eventBus.$emit(
        SHOW_SNACKBAR,
        'GIF files are not supported in the Video Vault. Please upload in the Brand Center instead.',
      );
      return;
    }
    this.showTimeEstimate();
    await brandModule.createBrandAsset({
      asset: this.localAsset,
      assetFile: this.assetFile,
    });
    if (errorModule.hasError) {
      errorModule.clearError();
      return;
    }
    this.localAsset = placeholderAsset;
    this.assetFile = null;
    eventBus.$emit(SHOW_SNACKBAR, 'Asset successfully created.');
  }

  showTimeEstimate(): void {
    if (!this.assetFile) {
      return;
    }
    const fileSizeInMB = this.assetFile.size / (1024 * 1024);
    // Average upload speed in US is 15 Mbps. Multiply MB by 8
    // to get us Mb, and divide the avergae Mbps to get us a time
    // estimate in seconds.
    const estimatedTimeInSeconds = (8 * fileSizeInMB) / 15;
    const estimatedTimeInMinutes = Math.round(estimatedTimeInSeconds / 60);
    eventBus.$emit(
      SHOW_SNACKBAR,
      `Estimated upload time: ${estimatedTimeInMinutes} minutes. Please leave this window open until the upload is complete.`,
    );
  }

  downloadImage(): void {
    const a = document.createElement('a');
    a.target = '_blank';
    a.href = `${ASSET_URL}${this.asset.full_size_url}`;
    a.click();
  }
}
